import React, {

    useEffect

} from 'react'

import {

    AreaChart,

    Area,

    Line,

    CartesianGrid,

    XAxis,

    YAxis,

    Tooltip,

    ResponsiveContainer,

    Legend

} from 'recharts'

import { useQuery } from 'react-query'

import {

    useForm,

    Controller

} from 'react-hook-form'

import api from '../../../components/api'

export default function DashboardComparacao(props) {

    const {

        adesao_institucional_id,

        anos,

        modo: modoDashboard = 'RELATORIO',
        exportandoPDF = false

    } = props

    const anosSelecionados =

        Array.isArray(anos)

            ? anos

                .map(item =>

                    Number(item)

                )

                .filter(item =>

                    Number.isInteger(item) &&

                    item > 0

                )

                .sort(

                    (a, b) =>

                        a - b

                )

            : []

    // =========================================================

    // FORMULÁRIO / FILTROS

    // =========================================================

    const {

        control,

        watch,

        setValue

    } = useForm({

        defaultValues: {

            anoReferencia:

                anosSelecionados.length > 0

                    ? anosSelecionados[

                        anosSelecionados.length - 1

                    ]

                    : '',

            grupoResiduo_id: '',

            subGrupoResiduo_id: '',

            tipoTratamento_id: '',

            indicador: 'kg'

        }

    })

    const anoReferencia =

        watch('anoReferencia')

    const grupoResiduo_id =

        watch('grupoResiduo_id')

    const subGrupoResiduo_id =

        watch('subGrupoResiduo_id')

    const tipoTratamento_id =

        watch('tipoTratamento_id')

    const indicador =

        watch('indicador')

    useEffect(() => {

        // Nenhum ano selecionado no filtro principal

        if (

            anosSelecionados.length === 0

        ) {

            setValue(

                'anoReferencia',

                ''

            )

            return

        }

        const anoAtual =

            Number(anoReferencia)

        // Se o ano atual ainda pertence à seleção,

        // não fazemos nada.

        if (

            anosSelecionados.includes(

                anoAtual

            )

        ) {

            return

        }

        // Caso contrário, seleciona automaticamente

        // o maior ano disponível.

        setValue(

            'anoReferencia',

            anosSelecionados[

                anosSelecionados.length - 1

            ]

        )

    }, [

        anosSelecionados.join(','),

        anoReferencia,

        setValue

    ])

    // =========================================================

    // GRUPOS

    // =========================================================

    const {

        data: grupos = [],

        isLoading: loadingGrupos

    } = useQuery({

        queryKey: [

            'grupoResidComparacao'

        ],

        queryFn: async () => {

            const result =

                await api.get(

                    'grupoResid'

                )

            return result.data ?? []

        }

    })

    // =========================================================

    // SUBGRUPOS

    // =========================================================

    const {

        data: subgrupos = [],

        isLoading: loadingSubgrupos

    } = useQuery({

        queryKey: [

            'subGrupoResidComparacao',

            grupoResiduo_id

        ],

        queryFn: async () => {

            const result =

                await api.get(

                    `subGrupoResid/${grupoResiduo_id}`

                )

            return result.data ?? []

        },

        enabled:

            !!grupoResiduo_id

    })

    // =========================================================

    // TRATAMENTOS

    // =========================================================

    const {

        data: tratamentos = [],

        isLoading: loadingTratamentos

    } = useQuery(

        'tipoTratamentoTodosDashboard',

        async () => {

            const result =

                await api.get(

                    'tipoTratamentoTodos'

                )

            return result.data || []

        },

        {

            refetchOnWindowFocus: false,

            staleTime: 5 * 60 * 1000

        }

    )

    // =========================================================

    // DASHBOARD

    // =========================================================

    const {

        data,

        isLoading,

        isFetching,

        isError

    } = useQuery({

        queryKey: [

            'residuosDashboardComparacao',

            adesao_institucional_id,

            anosSelecionados.join(','),

            anoReferencia,

            modoDashboard,

            grupoResiduo_id,

            subGrupoResiduo_id,

            tipoTratamento_id,

            indicador

        ],

        queryFn: async () => {

            const result =

                await api.post(

                    'residuosDashboardComparacao',

                    {

                        adesao_institucional_id:

                            Number(

                                adesao_institucional_id

                            ),

                        anos:

                            anosSelecionados,

                        anoReferencia:

                            anoReferencia

                                ? Number(

                                    anoReferencia

                                )

                                : null,

                        modo:

                            modoDashboard,

                        grupoResiduo_id:

                            grupoResiduo_id

                                ? Number(

                                    grupoResiduo_id

                                )

                                : null,

                        subgrupoResiduo_id:

                            subGrupoResiduo_id

                                ? Number(

                                    subGrupoResiduo_id

                                )

                                : null,

                        tipoTratamento_id:

                            tipoTratamento_id

                                ? Number(

                                    tipoTratamento_id

                                )

                                : null,

                        indicador:

                            indicador || 'kg'

                    }

                )

            return result.data

        },

        enabled:

            !!adesao_institucional_id &&

            (

                anosSelecionados.length === 0 ||

                !!anoReferencia

            )

    })

    const unidade =

        data?.unidade || 'kg'

    const descricaoIndicador =

        data?.descricaoIndicador || 'Quilograma'

    const indicadorSelecionado =

        data?.indicador || indicador || 'kg'

    const anoExibicao =

        data?.ano ??

        anoReferencia

    const ultimoRegistro =

        [...(data?.dados ?? [])]

            .reverse()

            .find(

item =>

                    item.atual !== null &&

                    item.atual !== undefined

            )

    const possuiPendenciaAtual =

        modoDashboard === 'CORRECAO' &&

        ultimoRegistro?.possuiPendenciaAtual === true

    const possuiPendenciaHistorico =

        modoDashboard === 'CORRECAO' &&

        ultimoRegistro?.possuiPendenciaHistorico === true

    const possuiPendenciaComparacaoAnoAnterior =

        modoDashboard === 'CORRECAO' &&

        (

            possuiPendenciaAtual ||

            data?.resumo?.possuiPendenciaAnoAnterior === true

        )

    const possuiPendenciaComparacaoHistorica =

        possuiPendenciaAtual ||

        possuiPendenciaHistorico

    // =========================================================

    // ALTERA GRUPO

    // =========================================================

    const alteraGrupo = (

field,

valor

    ) => {

        field.onChange(valor)

        setValue(

            'subGrupoResiduo_id',

            ''

        )

    }

    // =========================================================

    // ALTERA SUBGRUPO

    // =========================================================

    const alteraSubGrupo = (

field,

valor

    ) => {

        field.onChange(valor)

    }

    // =========================================================

    // FORMATA NÚMERO

    // =========================================================

    const formataNumero = (valor) => {

        if (

            valor === null ||

            valor === undefined

        ) {

            return '—'

        }

        return Number(

            valor

        ).toLocaleString(

            'pt-BR',

            {

                minimumFractionDigits: 1,

                maximumFractionDigits: 2

            }

        )

    }

    // =========================================================

    // FORMATA PERCENTUAL

    // =========================================================

    const formataPercentual = (valor) => {

        if (

            valor === null ||

            valor === undefined

        ) {

            return '—'

        }

        const numero =

            Number(valor)

        const prefixo =

            numero > 0

                ? '+'

                : ''

        return (

            `${prefixo}${numero.toLocaleString(

                'pt-BR',

                {

                    minimumFractionDigits: 1,

                    maximumFractionDigits: 2

                }

            )}%`

        )

    }

    // =========================================================

    // DADOS DO GRÁFICO

    //

    // Precisamos criar:

    //

    // baseHistorica = mínimo

    // faixaHistorica = máximo - mínimo

    //

    // Isso permite desenhar a faixa mínimo/máximo usando

    // duas áreas empilhadas.

    // =========================================================

    const dadosGrafico =

        (data?.dados ?? []).map(

item => {

                const minimo =

                    item.minimo !== null &&

                    item.minimo !== undefined

                        ? Number(

                            item.minimo

                        )

                        : null

                const maximo =

                    item.maximo !== null &&

                    item.maximo !== undefined

                        ? Number(

                            item.maximo

                        )

                        : null

                return {

                    ...item,

                    baseHistorica:

                        minimo,

                    faixaHistorica:

                        minimo !== null &&

                        maximo !== null

                            ? Number(

                                (

                                    maximo -

                                    minimo

                                ).toFixed(2)

                            )

                            : null,

                    linhaAtualNormal:

                        item.possuiPendenciaAtual

                            ? null

                            : item.atual,

                    linhaAtualPendencia:

                        item.possuiPendenciaAtual

                            ? item.atual

                            : null,

                    baseHistoricaPendencia:

                        item.possuiPendenciaHistorico

                            ? minimo

                            : null,

                    faixaHistoricaPendencia:

                        item.possuiPendenciaHistorico &&

                        minimo !== null &&

                        maximo !== null

                            ? Number(

                                (

                                    maximo -

                                    minimo

                                ).toFixed(2)

                            )

                            : null

                }

            }

        )

    // =========================================================

    // TOOLTIP PERSONALIZADO

    // =========================================================

    const TooltipComparacao = ({

        active,

        payload,

        label

    }) => {

        if (

            !active ||

            !payload ||

            payload.length === 0

        ) {

            return null

        }

        const registro =

            payload[0]?.payload

        if (!registro) {

            return null

        }

        return (

            <div

style={{

                    backgroundColor:

                        '#ffffff',

                    border:

                        '1px solid #d7dce1',

                    borderRadius:

                        '8px',

                    padding:

                        '12px 14px',

                    boxShadow:

                        '0 3px 12px rgba(0,0,0,0.12)',

                    minWidth:

                        '210px'

                }}

            >

                <div

style={{

                        fontWeight:

                            '600',

                        marginBottom:

                            '8px',

                        color:

                            '#333'

                    }}

                >

                    {label}

                </div>

                {anoExibicao && (

                    <div

style={{

                            fontSize: '13px',

                            marginBottom: '4px'

                        }}

                    >

                        {anoExibicao}:{' '}

                        <strong>

                            {formataNumero(

                                registro.atual

                            )} {unidade}

                        </strong>

                    </div>

                )}

                <div

style={{

                        fontSize:

                            '13px',

                        marginBottom:

                            '4px'

                    }}

                >

                    Média histórica:{' '}

                   <strong>

                        {formataNumero(

                            registro.media

                        )} {unidade}

                    </strong>

                </div>

                {modoDashboard === 'CORRECAO' &&

                    registro.possuiPendenciaAtual && (

                        <div

style={{

                                fontSize: '12px',

                                color: '#e67e22',

                                fontWeight: '600',

                                marginTop: '6px',

                                marginBottom: '6px'

                            }}

                        >

                            <i

className="fa fa-exclamation-triangle"

style={{

                                    marginRight: '5px'

                                }}

                            />

                            Trajetória contém dados com pendência

                        </div>

                    )

                }

                <div

style={{

                        fontSize:

                            '13px',

                        marginBottom:

                            '4px'

                    }}

                >

                    Mínimo histórico:{' '}

                    <strong>

                        {formataNumero(

                            registro.minimo

                        )} {unidade}

                    </strong>

                </div>

                <div

style={{

                        fontSize:

                            '13px'

                    }}

                >

                    Máximo histórico:{' '}

                    <strong>

                        {formataNumero(

                            registro.maximo

                        )} {unidade}

                    </strong>

                </div>

                {modoDashboard === 'CORRECAO' &&

                    registro.possuiPendenciaHistorico && (

                        <div

style={{

                                fontSize: '12px',

                                color: '#e67e22',

                                fontWeight: '600',

                                marginTop: '6px'

                            }}

                        >

                            <i

className="fa fa-exclamation-triangle"

style={{

                                    marginRight: '5px'

                                }}

                            />

                            Histórico contém dados com pendência

                        </div>

                    )

                }

                {registro.quantidadeAnosHistorico > 0 && (

                    <div

style={{

                            fontSize:

                                '11px',

                            color:

                                '#777',

                            marginTop:

                                '8px'

                        }}

                    >

                        Histórico calculado com{' '}

                        {

                            registro

                                .quantidadeAnosHistorico

                        }{' '}

                        ano(s)

                    </div>

                )}

            </div>

        )

    }

    // =========================================================

    // LOADING

    // =========================================================

    if (isLoading) {

        return (

            <div

className="text-center"

style={{

                    padding:

                        '50px'

                }}

            >

                <i

className="fa fa-spinner fa-spin"

style={{

                        fontSize:

                            '26px'

                    }}

                />

                <div

style={{

                        marginTop:

                            '10px',

                        color:

                            '#777'

                    }}

                >

                    Carregando comparação...

                </div>

            </div>

        )

    }

    // =========================================================

    // ERRO

    // =========================================================

    if (isError) {

        return (

            <div

className="alert alert-danger"

            >

                Não foi possível carregar o dashboard de comparação.

            </div>

        )

    }

    return (

        <div>

            {/* =====================================================

                FILTROS

               \===================================================== */}

            <div

className="row"

style={{

                    marginBottom:

                        '25px'

                }}

            >

                {/* ANO DE REFERÊNCIA */}

                    <div className="col-md-2">

                        <label>

                            Ano de referência

                        </label>

                        <Controller

name="anoReferencia"

control={control}

render={({ field }) => (

                                <select

                                    {...field}

className="form-control"

disabled={

                                        anosSelecionados.length === 0

                                    }

                                >

                                    {anosSelecionados.length === 0 && (

                                        <option value="">

                                            Nenhum ano selecionado

                                        </option>

                                    )}

                                    {anosSelecionados.map(

ano => (

                                            <option

key={ano}

value={ano}

                                            >

                                                {ano}

                                            </option>

                                        )

                                    )}

                                </select>

                            )}

                        />

                    </div>

                {/* GRUPO */}

                <div className="col-md-2">

                    <label>

                        Grupo de resíduo

                    </label>

                    <Controller

name="grupoResiduo_id"

control={control}

render={({ field }) => (

                            <select

                                {...field}

className="form-control"

disabled={

                                    loadingGrupos

                                }

onChange={e => {

                                    alteraGrupo(

                                        field,

                                        e.target.value

                                    )

                                }}

                            >

                                <option value="">

                                    Todos

                                </option>

                                {grupos.map(item => (

                                    <option

key={

                                            item.grupoResiduo_id

                                        }

value={

                                            item.grupoResiduo_id

                                        }

                                    >

                                        {

                                            item.grupoResiduo_descri

                                        }

                                    </option>

                                ))}

                            </select>

                        )}

                    />

                </div>

                {/* SUBGRUPO */}

                <div className="col-md-2">

                    <label>

                        Subgrupo

                    </label>

                    <Controller

name="subGrupoResiduo_id"

control={control}

render={({ field }) => (

                            <select

                                {...field}

className="form-control"

disabled={

                                    !grupoResiduo_id ||

                                    loadingSubgrupos

                                }

onChange={e => {

                                    alteraSubGrupo(

                                        field,

                                        e.target.value

                                    )

                                }}

                            >

                                <option value="">

                                    Todos

                                </option>

                                {subgrupos.map(item => (

                                    <option

key={

                                            item.subGrupoResiduo_id

                                        }

value={

                                            item.subGrupoResiduo_id

                                        }

                                    >

                                        {

                                            item.subGrupoResiduo_descri

                                        }

                                    </option>

                                ))}

                            </select>

                        )}

                    />

                </div>

                {/* TRATAMENTO */}

                <div className="col-md-2">

                    <label>

                        Tratamento / Destinação

                    </label>

                    <Controller

name="tipoTratamento_id"

control={control}

render={({ field }) => (

                                <select

                                    {...field}

className="form-control"

disabled={

                                        loadingTratamentos

                                    }

                                >

                                    <option value="">

                                        Todos

                                    </option>

                                    {tratamentos.map(rs => (

                                        <option

key={

                                                rs.tipoTratamento_id

                                            }

value={

                                                rs.tipoTratamento_id

                                            }

                                        >

                                            {

                                                rs.tipoTratamento_descri

                                            }

                                        </option>

                                    ))}

                                </select>

                            )}

                        />

                </div>

                {/* =================================================

                    INDICADOR

                    \================================================= */}

                <div className="col-md-2">

                    <div className="form-group">

                        <label>

                            Pesagem

                        </label>

                        <Controller

name="indicador"

control={control}

render={({ field }) => (

                                <select

                                    {...field}

className="form-control"

                                >

                                    <option value="kg">

                                        Quilograma (kg)

                                    </option>

                                    <option value="kg_fte">

                                        kg/FTE

                                    </option>

                                    <option value="kg_paciente_dia">

                                        kg/Paciente Dia

                                    </option>

                                    <option value="kg_area">

                                        kg/Área construída

                                    </option>

                                </select>

                            )}

                        />

                    </div>

                </div>

            </div>

            {/* =====================================================

                CABEÇALHO

               \===================================================== */}

            <div

className="d-flex justify-content-between align-items-center"

style={{

                    marginBottom:

                        '15px'

                }}

            >

                <div>

                    <h4

style={{

                            margin:

                                0,

                            fontWeight:

                                '600',

                            color:

                                '#333'

                        }}

                    >

                        Comparação com o passado

                    </h4>

                    <div

style={{

                            fontSize:

                                '13px',

                            color:

                                '#777',

                            marginTop:

                                '4px'

                        }}

                    >

                        {anoExibicao

                            ? `Geração acumulada de ${anoExibicao} comparada ao histórico`

                            : 'Faixa e média histórica de geração acumulada'

                        }

                    </div>

                </div>

                {isFetching && (

                    <div

style={{

                            fontSize:

                                '12px',

                            color:

                                '#777'

                        }}

                    >

                        <i

className="fa fa-spinner fa-spin"

style={{

                                marginRight:

                                    '5px'

                            }}

                        />

                        Atualizando...

                    </div>

                )}

            </div>

            {/* =====================================================

                GRÁFICO + CARDS

               \===================================================== */}

            <div className="row">

                {/* =================================================

                    GRÁFICO

                   \================================================= */}

                <div className="col-md-9">

                    <div

style={{

                            height:

                                '480px',

                            border:

                                '1px solid #e1e5e9',

                            borderRadius:

                                '10px',

                            padding:

                                '20px',

                            backgroundColor:

                                '#ffffff',

                            boxShadow:

                                '0 2px 8px rgba(0,0,0,0.04)'

                        }}

                    >

                        <ResponsiveContainer

width="100%"

height="100%"

                        >

                            <AreaChart

data={

                                    dadosGrafico

                                }

margin={{

                                    top:

                                        20,

                                    right:

                                        30,

                                    left:

                                        20,

                                    bottom:

                                        20

                                }}

                            >

                                <defs>

                                    <pattern

id="comparacaoPendenciaPattern"

width="8"

height="8"

patternUnits="userSpaceOnUse"

patternTransform="rotate(45)"

                                    >

                                        <line

x1="0"

y1="0"

x2="0"

y2="8"

stroke="#e67e22"

strokeWidth="3"

                                        />

                                    </pattern>

                                </defs>

                                <CartesianGrid

strokeDasharray="3 3"

                                />

                                <XAxis

dataKey="periodo"

                                />

                                <YAxis

tickFormatter={

value =>

                                            Number(

                                                value

                                            ).toLocaleString(

                                                'pt-BR'

                                            )

                                    }

                                />

                                <Tooltip

content={

                                        <TooltipComparacao />

                                    }

                                />

                                {/* =================================

                                    BASE INVISÍVEL DA FAIXA

                                   \================================= */}

                                <Area

type="monotone"

dataKey="baseHistorica"

stackId="historico"

stroke="none"

fill="transparent"

legendType="none"

connectNulls={

                                        false

                                    }

                                isAnimationActive={!exportandoPDF}
                                />

                                {/* =================================

                                    FAIXA MÍNIMO → MÁXIMO

                                   \================================= */}

                                <Area

type="monotone"

dataKey="faixaHistorica"

stackId="historico"

name="Faixa histórica"

stroke="#9cc9eb"

fill="#dceeff"

fillOpacity={

                                        0.75

                                    }

connectNulls={

                                        false

                                    }

                                isAnimationActive={!exportandoPDF}
                                />

                                {modoDashboard === 'CORRECAO' && (

                                    <>

                                        <Area

type="monotone"

dataKey="baseHistoricaPendencia"

stackId="historicoPendencia"

stroke="none"

fill="transparent"

legendType="none"

connectNulls={false}

isAnimationActive={!exportandoPDF}

                                        />

                                        <Area

type="monotone"

dataKey="faixaHistoricaPendencia"

stackId="historicoPendencia"

name="Faixa histórica com pendência"

stroke="#e67e22"

strokeDasharray="6 4"

strokeWidth={2}

fill="url(#comparacaoPendenciaPattern)"

fillOpacity={0.75}

connectNulls={false}

isAnimationActive={!exportandoPDF}

                                        />

                                    </>

                                )}

                                {/* =================================

                                    MÉDIA HISTÓRICA

                                   \================================= */}

                                <Line

type="monotone"

dataKey="media"

name="Média histórica"

stroke="#555555"

strokeWidth={

                                        2.5

                                    }

dot={

                                        false

                                    }

connectNulls={

                                        false

                                    }

                                isAnimationActive={!exportandoPDF}
                                />

                                {/* =================================

                                    TRAJETÓRIA DO ANO SELECIONADO

                                \================================= */}

                                {anoExibicao && (

                                    <>

                                        <Line

type="monotone"

dataKey="linhaAtualNormal"

name={`Trajetória ${anoExibicao}`}

stroke="#1683c7"

strokeWidth={4}

dot={{

                                                r: 4,

                                                fill: '#1683c7',

                                                stroke: '#ffffff',

                                                strokeWidth: 2

                                            }}

activeDot={{

                                                r: 7,

                                                fill: '#1683c7',

                                                stroke: '#ffffff',

                                                strokeWidth: 2

                                            }}

connectNulls={false}

isAnimationActive={!exportandoPDF}

animationDuration={500}

                                        />

                                        {modoDashboard === 'CORRECAO' && (

                                            <Line

type="monotone"

dataKey="linhaAtualPendencia"

name={`Trajetória ${anoExibicao} com pendência`}

stroke="#e67e22"

strokeWidth={4}

strokeDasharray="7 5"

dot={{

                                                    r: 4,

                                                    fill: '#e67e22',

                                                    stroke: '#ffffff',

                                                    strokeWidth: 2

                                                }}

activeDot={{

                                                    r: 7,

                                                    fill: '#e67e22',

                                                    stroke: '#ffffff',

                                                    strokeWidth: 2

                                                }}

connectNulls={false}

isAnimationActive={!exportandoPDF}

                                            />

                                        )}

                                    </>

                                )}

                                <Legend />

                            </AreaChart>

                        </ResponsiveContainer>

                    </div>

                </div>

                {/* =================================================

                    CARDS

                   \================================================= */}

                <div className="col-md-3">

                    {/* =============================================

                        ANO ANTERIOR

                       \============================================= */}

                    <div

style={{

                            minHeight:

                                '220px',

                            border:

                                possuiPendenciaComparacaoAnoAnterior

                                    ? '2px dashed #e67e22'

                                    : '1px solid #1683c7',

                            borderRadius:

                                '12px',

                            padding:

                                '22px',

                            backgroundColor:

                                possuiPendenciaComparacaoAnoAnterior

                                    ? '#fffaf5'

                                    : '#f5fbff',

                            marginBottom:

                                '20px',

                            display:

                                'flex',

                            flexDirection:

                                'column',

                            justifyContent:

                                'center',

                            textAlign:

                                'center'

                        }}

                    >

                        <div

style={{

                                fontSize:

                                    '14px',

                                lineHeight:

                                    '1.4',

                                color:

                                    '#555'

                            }}

                        >

                            Geração até o momento

                            <br />

                            em comparação com

                            <br />

                            {data?.anoAnterior

                                ? `o ano de ${data.anoAnterior}`

                                : 'o ano anterior'

                            }

                        </div>

                        <div

style={{

                                fontSize:

                                    '38px',

                                fontWeight:

                                    '700',

                                marginTop:

                                    '15px',

                                color:

                                    '#1683c7'

                            }}

                        >

                            {formataPercentual(

                                data?.comparacaoAnoAnterior

                            )}

                        </div>

                        {possuiPendenciaComparacaoAnoAnterior && (

                            <div

style={{

                                    marginTop: '10px',

                                    fontSize: '12px',

                                    color: '#e67e22',

                                    fontWeight: '600'

                                }}

                            >

                                <i

className="fa fa-exclamation-triangle"

style={{

                                        marginRight: '5px'

                                    }}

                                />

                                Contém dados com pendência

                            </div>

                        )}

                        {data?.resumo && (

                            <div

style={{

                                    fontSize:

                                        '11px',

                                    color:

                                        '#777',

                                    marginTop:

                                        '12px'

                                }}

                            >

                                {formataNumero(

                                    data.resumo.acumuladoAtual

                                )} {unidade}

                                {' / '}

                                {formataNumero(

                                    data.resumo.acumuladoAnoAnterior

                                )} {unidade}

                            </div>

                        )}

                    </div>

                    {/* =============================================

                        MÉDIA HISTÓRICA

                       \============================================= */}

                    <div

style={{

                            minHeight:

                                '220px',

                            border:

                                possuiPendenciaComparacaoHistorica

                                    ? '2px dashed #e67e22'

                                    : '1px solid #1683c7',

                            borderRadius:

                                '12px',

                            padding:

                                '22px',

                            backgroundColor:

                                possuiPendenciaComparacaoHistorica

                                    ? '#fffaf5'

                                    : '#f5fbff',

                            display:

                                'flex',

                            flexDirection:

                                'column',

                            justifyContent:

                                'center',

                            textAlign:

                                'center'

                        }}

                    >

                        <div

style={{

                                fontSize:

                                    '14px',

                                lineHeight:

                                    '1.4',

                                color:

                                    '#555'

                            }}

                        >

                            Geração até o momento

                            <br />

                            em comparação com a

                            <br />

                            geração média histórica

                        </div>

                        <div

style={{

                                fontSize:

                                    '38px',

                                fontWeight:

                                    '700',

                                marginTop:

                                    '15px',

                                color:

                                    '#1683c7'

                            }}

                        >

                            {formataPercentual(

                                data

                                    ?.comparacaoMediaHistorica

                            )}

                        </div>

                        {possuiPendenciaComparacaoHistorica && (

                            <div

style={{

                                    marginTop: '10px',

                                    fontSize: '12px',

                                    color: '#e67e22',

                                    fontWeight: '600'

                                }}

                            >

                                <i

className="fa fa-exclamation-triangle"

style={{

                                        marginRight: '5px'

                                    }}

                                />

                                Contém dados com pendência

                            </div>

                        )}

                        {data?.resumo && (

                            <div

style={{

                                    fontSize:

                                        '11px',

                                    color:

                                        '#777',

                                    marginTop:

                                        '12px'

                                }}

                            >

                                {formataNumero(

                                    data.resumo.acumuladoAtual

                                )} {unidade}

                                {' / '}

                                {formataNumero(

                                    data.resumo.mediaHistorica

                                )} {unidade}

                            </div>

                        )}

                    </div>

                </div>

            </div>

            {/* =====================================================

                RODAPÉ INFORMATIVO

               \===================================================== */}

            {anoExibicao && data?.ultimoMesReportado && (

                <div

style={{

                        fontSize:

                            '12px',

                        color:

                            '#777',

                        marginTop:

                            '10px'

                    }}

                >

                    A geração de {anoExibicao} está representada até{' '}

                    <strong>

                        {

                            dadosGrafico.find(

item =>

                                    item.ordem ===

                                    data.ultimoMesReportado

                            )?.periodo

                        }

                    </strong>.

                    {' '}

                    A faixa histórica considera{' '}

                    <strong>

                        {

                            data?.anosHistoricos

                                ?.join(', ') || 'nenhum'

                        }

                    </strong>{' '}

                    como período histórico.

                </div>

            )}

        </div>

    )

}